import React from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import config from '../config.js'

import {fetchDataIfReady, fetchDataIfUndefined, clearStateBlock} from 'Skelet/src/modules/fetch.action.js'
import Graph from 'Skelet/src/components/Graph.js'
import {time_ago_txt} from 'Skelet/src/modules/time_ago.js'
import refresh_icon from './28406.svg';


class Items extends React.Component {

  componentWillMount() {
    if(this.props.session_token) {
      this.props.fetchDataIfReady(config.api_token, "item_list", "GET", config.api_url+"/list?t="+this.props.session_token);
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.session_token) {
      this.props.fetchDataIfUndefined(config.api_token, "item_list", "GET", config.api_url+"/list?t="+nextProps.session_token);
    }
  }

  render() {
    let card = null, cards = null, end_of_list_text = "", page_cards = this.props.apiData["item_list"];
    if(page_cards !== undefined) {
      cards = page_cards.data.map(function(item, i) {
        item.time_ago_txt = time_ago_txt(item.created_on);

        return <div key={"1k"+i} id={"ntfy-"+i} className="contact notification">
          <div className="contact-name">{item.title}</div>
          <small style={{opacity:".5", display:"block", fontSize:"75%"}}>{item.time_ago_txt}</small>
          <span className="btn" onClick={(e) => {e.preventDefault();this.markRead(item.id, i)}}>read</span>
        </div>;
      }.bind(this));
      card = <div className="card contacts">{cards}</div>;
    }

    if(page_cards === undefined || page_cards.isFetching) {
      end_of_list_text = "Laden..";
    } else if((page_cards !== undefined && !page_cards.isFetching)) {
      if(page_cards.data[0] !== undefined) {
        end_of_list_text = "Einde van resultaten.";
      } else {
        end_of_list_text = "Geen notificaties.";
      }
    }

    return (
      <div className="container content" ref={this.setWrapperRef}>
        <div className="card-layout">
          <div className="card-layout-div50"><strong>Notificaties</strong></div>
          <div className="card-layout-div50 refresher"><img src={refresh_icon} alt="Vernieuwen" onClick={() => this.refresh()}/></div>
        </div>
        {page_cards !== undefined && <Graph data={page_cards.data} />}
        {page_cards !== undefined && page_cards.data[0] !== undefined && card}
        <div className="end_of_list_text">{end_of_list_text}</div>
      </div>
    );
  }

  refresh() {
    this.props.clearStateBlock("item_list");
  }

  markRead(id, i) {
    document.getElementById("ntfy-"+i).style.opacity=".3";
    this.props.fetchDataIfReady(config.api_token, "bin", "PATCH", config.api_url+"/update-status?t="+this.props.session_token, JSON.stringify({id:id, status:"0"}), null, true);
  }

}


function mapStateToProps(state) {
  let session_token = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  return {
    session_token: session_token,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    fetchDataIfUndefined,
    clearStateBlock,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Items)



// WEBPACK FOOTER //
// ./src/containers/Items.js